query GetCardAccountTags($id: UUID!) {
  cardAccount(id: $id) {
    id
    entityTagsByEntityId {
      nodes {
        id
        _isDeletable
        _tagBadgeName
        _tagBadgeColor
        _rowTimestamp
        createdByUser
        _createdDate
      }
    }
  }
}
